export default "__VITE_ASSET__Ddki5joC__"